module.exports = __webpack_public_path__ + "media/video.4fb6bf51.mp4";